module.exports = __webpack_public_path__ + "img/streaming-icon.00d5535d.svg";